import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	max-width: 450px;
	background-color: white;
	border-radius: 10px;
	box-shadow: 0 4px 10px -6px rgba(0, 0, 45, 0.7);
	padding: 30px;
`;

export const ErrorAlert = styled.div`
	width: 100%;
`;
